import Tooltip from '@carvana/showroom-tooltip';
import cx from 'classnames';
import type React from 'react';
import InfoStandardSmall from '~/icons/srp/InfoStandardSmall';
import styles from './ConditionalTile.module.scss';
import CTContent from './CTContent';
import CTIcon from './CTIcon';

type ToolTip = {
  strong: string;
  text: string;
};

type Content = {
  heading1?: string;
  heading2?: string;
  subHeading: string;
};

export type ConditionalTileData = {
  button?: string;
  content: Content;
  tooltip?: ToolTip;
};

type OwnProps = {
  backgroundButton?: boolean;
  data: ConditionalTileData;
  hasButton?: boolean;
  hasMobileSubText?: boolean;
  hasToolTip?: boolean;
  hideIcon?: boolean;
  isMobile?: boolean;
  light?: boolean;
  primaryButton?: boolean;
  small?: boolean;
  svgIcon?: React.ReactNode;
  top?: boolean;
  useMobileIcon?: boolean;
};

export default function ConditionalTile({
  backgroundButton = false,
  data: { tooltip, content, button },
  hasButton = false,
  hasMobileSubText = false,
  hasToolTip = true,
  hideIcon = false,
  isMobile,
  light = false,
  primaryButton = false,
  small = false,
  svgIcon,
  top = false,
  useMobileIcon
}: OwnProps) {
  return (
    <div className={cx(styles.ctContainer, { top, small })}>
      {hasToolTip && (
        <div className="absolute right-12 top-8">
          <Tooltip
            content={<p className="tl-body-xs m:tl-body-s">{tooltip?.text}</p>}
            title={tooltip?.strong}
            direction="bottom-end"
            display={{
              contentOffsetX: 16
            }}
          >
            <InfoStandardSmall
              className={light ? 'text-white' : 'text-grey-3'}
            />
          </Tooltip>
        </div>
      )}
      <div
        className={cx(styles.ctContentWrapper, {
          mobile: isMobile,
          top,
          small
        })}
      >
        <CTIcon
          hideIcon={hideIcon}
          isMobile={isMobile}
          svgIcon={svgIcon}
          useMobileIcon={useMobileIcon}
        />
        <CTContent
          options={content}
          buttonText={button}
          button={hasButton}
          top={top}
          light={light}
          backgroundButton={backgroundButton}
          primaryButton={primaryButton}
          isMobile={isMobile}
          hasMobileSubText={hasMobileSubText}
        />
      </div>
    </div>
  );
}
